var _mask, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6638_19339",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "url(#paint0_linear_6638_19339)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0V1H22V0V-1H10V0ZM32 10H31V22H32H33V10H32ZM22 32V31H10V32V33H22V32ZM0 22H1V10H0H-1V22H0ZM10 32V31C5.02944 31 1 26.9706 1 22H0H-1C-1 28.0751 3.92487 33 10 33V32ZM32 22H31C31 26.9706 26.9706 31 22 31V32V33C28.0751 33 33 28.0751 33 22H32ZM22 0V1C26.9706 1 31 5.02944 31 10H32H33C33 3.92487 28.0751 -1 22 -1V0ZM10 0V-1C3.92487 -1 -1 3.92487 -1 10H0H1C1 5.02944 5.02944 1 10 1V0Z",
    fill: "#AD46FF",
    fillOpacity: 0.3,
    mask: "url(#path-1-inside-1_6638_19339)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6638_19339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9789 9.22444C12.1946 9.05193 12.2295 8.73729 12.057 8.52166C11.8845 8.30602 11.5699 8.27106 11.3542 8.44357L9.68757 9.7769C9.47194 9.94941 9.43698 10.2641 9.60948 10.4797C9.78199 10.6953 10.0966 10.7303 10.3123 10.5578L11.9789 9.22444Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6456 8.44357C20.43 8.27106 20.1153 8.30602 19.9428 8.52166C19.7703 8.73729 19.8053 9.05193 20.0209 9.22444L21.6876 10.5578C21.9032 10.7303 22.2178 10.6953 22.3904 10.4797C22.5629 10.2641 22.5279 9.94941 22.3123 9.7769L20.6456 8.44357Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 13.5007C16.4999 13.2245 16.2761 13.0007 15.9999 13.0007C15.7238 13.0007 15.4999 13.2245 15.4999 13.5007V16.3046C15.4999 16.5171 15.4187 16.7216 15.2729 16.8762L14.3028 17.9052C14.1133 18.1061 14.1227 18.4226 14.3236 18.612C14.5245 18.8015 14.841 18.7921 15.0304 18.5912L16.0005 17.5622C16.3213 17.222 16.4999 16.7721 16.4999 16.3046V13.5007Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 9.00067C12.0419 9.00067 8.83325 12.2093 8.83325 16.1673C8.83325 20.1254 12.0419 23.334 15.9999 23.334C19.958 23.334 23.1666 20.1254 23.1666 16.1673C23.1666 12.2093 19.958 9.00067 15.9999 9.00067ZM9.83325 16.1673C9.83325 12.7616 12.5942 10.0007 15.9999 10.0007C19.4057 10.0007 22.1666 12.7616 22.1666 16.1673C22.1666 19.5731 19.4057 22.334 15.9999 22.334C12.5942 22.334 9.83325 19.5731 9.83325 16.1673Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6638_19339",
    x1: 0,
    y1: 0,
    x2: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9810FA",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155DFC",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6638_19339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeVector);
export default __webpack_public_path__ + "static/media/TimeVector.67c1ff7f38b7d0c2e76e9fdbc6944f7c.svg";
export { ForwardRef as ReactComponent };